import { Route, Routes } from "react-router";
import Dashboard from "../Pages/Dashboard";
import Listing from "../Pages/Listing";
import OnlineInterview from "../Pages/OnlineInterview/Index";
import Profile from "../Pages/Profile";
import Requirements from "../Pages/Requirements/Index";
import SignIn from "../Pages/Signin";
import Signup from "../Pages/Signup";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedLogin from "./ProtectedLogin";
import ForgotPassword from "../Pages/ForgotPassword/Index";
import ResetPassword from "../Pages/ResetPassword/Index";
import NotFound from "../Pages/NotFound/Index";
import ProviderLoader from "../Pages/ProviderLoader/ProviderLoader";
import InterviewRounds from "../Pages/InterviewRounds";
import Result from "../Pages/Result";
import RootLayout from "../Components/Layout/RootLayout";
import { InterviewRoundProvider } from "../Context/InterviewRoundContext";

const Routing = () => {
  return (
    <Routes>
      <Route path="/provider" element={<ProviderLoader />} />
      <Route
        path="/"
        element={
          <RootLayout>
            <Listing />
          </RootLayout>
        }
      />
      <Route
        path="/sign-in"
        element={
          <ProtectedLogin>
            <SignIn />
          </ProtectedLogin>
        }
      />
      <Route
        path="/sign-up"
        element={
          <ProtectedLogin>
            <Signup />
          </ProtectedLogin>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <ProtectedLogin>
            <ForgotPassword />
          </ProtectedLogin>
        }
      />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />

      <Route
        path=":jobDescriptionId"
        element={
          <RootLayout>
            <Dashboard />
          </RootLayout>
        }
      >
        <Route path="requirements" element={<Requirements />} />
        <Route
          path="interview-round/:sessionId"
          element={
            <ProtectedRoute>
              <InterviewRoundProvider>
                <InterviewRounds />
              </InterviewRoundProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="online-interview"
          element={
            <ProtectedRoute>
              <OnlineInterview />
            </ProtectedRoute>
          }
        />
        <Route
          path="result"
          element={
            <ProtectedRoute>
              <Result />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default Routing;
